<template>
    <div id="login">
        <div class="fitbase-login_header">
            Войти в личный кабинет
        </div>

        <auth-form />

        <div class="fitbase-login_footer">
            Сделано на <a href="https://fitbase.io/?utm_source=widget&utm_campaign=account">fitbase.io</a>
        </div>
    </div>
</template>

<script>
    import AuthForm from "../components/AuthForm";

    export default {
        name: 'Login',
        components: { AuthForm }
    }
</script>
